import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NextConfig } from 'src/app/shared/configs/next.config';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {

    @Output() onNavMobCollapse = new EventEmitter();

    public windowWidth: number;
    public nextConfig: any;

    ngOnInit(): void {
        this.nextConfig = NextConfig.config;
        this.windowWidth = window.innerWidth;
    }

    navMobCollapse() {
        if (this.windowWidth < 992) {
            this.onNavMobCollapse.emit();
        }
    }
}
